import React from "react";
import { LinkProps, useParams } from "react-router-dom";
import { StyledRouterLink } from "./Link.styles";

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const { lang } = useParams<{ lang: string }>();
    const currentLang = lang || localStorage.getItem("i18nextLng") || "en";

    let localizedTo = to;

    if (typeof to === "string" && to.startsWith("/")) {
      const hasLangPrefix = /^\/[a-z]{2}(\/|$)/.test(to);

      if (!hasLangPrefix) {
        localizedTo = to === "/" ? `/${currentLang}` : `/${currentLang}${to}`;
      }
    }

    return <StyledRouterLink ref={ref} to={localizedTo} {...props} />;
  },
);

Link.displayName = "Link";
